module.exports = __webpack_public_path__ + "img/cross.1f3f5e39.svg";